import UrlBuilder from '../Frisco/UrlBuilder';
import { transformMeasurementUnit, transformMeasurementValue } from '../Frisco/ProductTransformer';
import { useAppContext, useTranslator } from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

const FriscoButton = ({ categories }) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  const {
    images: { friscoLogo },
  } = useAppContext();

  // limit cart url length
  const FRISCO_MAX_URL_LENGTH = 1024 * 5;

  const trackFriscoExport = (cartUrlWasTrimmed) => {
    trackFirebaseEvent('frisco', 'click');

    if (cartUrlWasTrimmed) {
      trackFirebaseEvent('frisco', 'clicked-on-trimmed-url');
    }
  };

  const getFriscoExportUrl = (productList) => {
    const friscoUrlBuilder = new UrlBuilder('Lista zakupów');

    productList.forEach((elem) => {
      if (elem.friscoProductId !== null) {
        const measurement = transformMeasurementUnit(elem.friscoProductUnit, elem.measurements);

        if (measurement !== undefined) {
          let productAmount = measurement.amount;
          if (measurement.unit === 'g' || measurement.unit === 'ml') {
            productAmount = measurement.amount * 0.001;
          }
          if (measurement.unit === 'oz') {
            productAmount = measurement.amount * 0.0283495;
          }
          if (measurement.unit === 'fl oz') {
            productAmount = measurement.amount * 0.0295735;
          }

          const amount = transformMeasurementValue(elem.friscoProductMeasure, productAmount);
          friscoUrlBuilder.addProduct(
            elem.friscoProductId,
            amount,
            elem.name,
            `${measurement.amount} ${measurement.unit}`
          );
        }
      }
    });

    let friscoCartUrl = friscoUrlBuilder.buildUrl();
    const nonTrimmedFriscoCartUrlLength = friscoCartUrl.length;
    let friscoCartUrlWasTrimmed = false;
    while (friscoCartUrl.length >= FRISCO_MAX_URL_LENGTH && friscoUrlBuilder.products.length > 0) {
      friscoUrlBuilder.productPop();
      friscoCartUrl = friscoUrlBuilder.buildUrl();
      friscoCartUrlWasTrimmed = true;
    }

    if (friscoCartUrlWasTrimmed) {
      trackFirebaseEvent(
        'frisco',
        'cart-url-was-trimmed',
        `shopping list url was trimmed by ${
          nonTrimmedFriscoCartUrlLength - friscoCartUrl.length
        } bytes`
      );
    }

    return { friscoCartUrl, friscoCartUrlWasTrimmed };
  };

  const productList = categories
    .map((elem) => elem.products)
    .flat()
    .filter((elem) => !elem.isBought);

  const { friscoCartUrl, friscoCartUrlWasTrimmed } = getFriscoExportUrl(productList);

  console.log('friscoURL', friscoCartUrl);

  return (
    <div className="text-center mb-xl">
      <a
        className="btn btn-frisco w-100"
        href={friscoCartUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackFriscoExport(friscoCartUrl, friscoCartUrlWasTrimmed)}
      >
        {t('orderIngredients.frisco.button')}{' '}
        <img
          src={friscoLogo}
          style={{
            verticalAlign: 'baseline',
            height: '13px',
          }}
          alt="instacart"
        />
      </a>
    </div>
  );
};

export default FriscoButton;
